import React, {useContext, useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import AdGroupFormZeus from "./AdGroupFormZeus";
import {
  AdGroupZeus,
  LogRecord,
  AudienceRelations,
  OsType,
  OsTargeting,
  AdGroupUpdate,
  DemographicRelation,
} from "./AdGroupModelZeus";
import {
  get_zeus_ad_group_path,
  get_zeus_ads
} from "../../../atom/Apollo_links";
import {ApolloRightDrawerContext} from "../../../molecule/Apollo_RightDrawer";
import {ApiResponse, ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {
  ApolloEventRecord,
  createLogDate, createUserLogItemListByOption,
  createUserLogItemListFromArrayAddSB,
  createUserLogItemListFromNumber,
  createUserLogItemListFromString,
  ItemList, LogData
} from "../../../atom/Apollo_EventRecord";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {
  Option,
  options_state_edit,
  valueToOptionNull,
  options_ostype_zeus_number,
  valueToOption,
  OS_TYPE_ZEUS_NUMBER,
  ZEUS_DELIVERY_TYPE,
} from "../../../atom/Apollo_styles";
import moment from "moment";
import {formatLogFromDemographics} from "../../../common/PLATFORM/zeus/FunctionZeus";
import {
  AFFINITY_CATEGORY_MAX_ZEUS,
  RETARGETING_MAX_ZEUS,
  TARGET_TYPE,
  options_zeus_ad_target,
} from "./common/CommonConst";
import {getAccountsDeletedAudience, getTrackerAudience} from "../../../common/Apollo_CommonUtil";
import {ApolloDialog} from "../../../atom/Apollo_Dialog";
import {ApolloConfirmNotActiveDialog} from "../../../organism/HERA/ConfirmNotActiveDialog";


type AdGroupData = {
  platformAccountId: string,
  adGroupId: number,
  listReloadFunc?: any;
}

type DemographicData = {
  genders: string[],
  address: string[],
  ageRanges: number[],
}


// 画面名：広告グループ編集（Zeus）- エキスパンド表示
const AdGroupEditZeus = ({platformAccountId, adGroupId, listReloadFunc}: AdGroupData) => {
 
  const {register, control, errors, setError, formState} = useForm();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const adGroupData = useRef<AdGroupZeus | null>(null);
  const beforeEditRecord = useRef<LogRecord | null>(null);
  const processing = useRef(false);
  const [hasAd, setHasAd] = useState(false);
  const [adGroup, setAdGroup] = useState<AdGroupZeus>({
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: 0,
    adAccountId: Number(platformAccountId),
    adCampaignId: 0,
    adCampaignName: "",
    deliveryType: 1,
    // menuId: 0,
    name: "",
    cpcLimit: 1,
    cpcLimitOver: true,
    // billingType: 0,
    status: 2,
    targetingType: 0,
    customSegmentId: 0,
    affinityCategoryIds: [],
    retargetingIds: [],
    demographicRelations: [],
    osTargetings: [],
    audienceRelations: [],
    segmentRelations: [],
    cpmLimit: 1,
    billingType: 1,
    pmpType: null,
    placementSettingId: null,
  });
  const [osType, setOsType] = useState<OsType>({
    pc: false,
    ios: false,
    android: false,
  });
  const [cpcLimitOver, setCpcLimitOver] = useState(true);
  const [isCpcLimitDisabled, setIsCpcLimitDisabled] = useState<boolean>(false);
  let [ageMin, setAgeMin] = useState<number | null>(null);
  let [ageMax, setAgeMax] = useState<number | null>(null);
  const [gender1, setGender1] = useState(false);
  const [gender2, setGender2] = useState(false);
  const [gender3, setGender3] = useState(false);
  const [checkedPref, setCheckedPref] = useState([false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, ]);
  const [prefRenderId, setPrefRenderId] = useState(0);
  const optionAudiences2 = useRef<Option[]>([]);
  const optionAffinityCategories2 = useRef<Option[]>([]);
  const optionCustomSegments2 = useRef<Option[]>([]);
  const isExistsNotActiveAudience = useRef<boolean>(false)
  const isExistsDeletedAudience = useRef<boolean>(false)
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)

  useEffect(() => {
    if (Number(adGroupId) === 0) return;
    processing.current = true;
    console.log(adGroupId);
    ApolloAxios.get(process.env.REACT_APP_API_ENDPOINT + get_zeus_ad_group_path + "/" + String(adGroupId)).then(response => {
      const res = response.data;
      if (response.status !== 200) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告グループ情報の取得に失敗しました",
        });
      }
      const resultData = res;
      
      let resMenuId = 0;
      if (resultData.menuId && resultData.menuId !== 0) {
        resMenuId = resultData.menuId;
      }

      const resOsTargetings: OsTargeting[] = resultData?.osTargetings ?? []
      let localOsType: OsType = {...osType}
      resOsTargetings.map(elem => {
        if (elem.osType === OS_TYPE_ZEUS_NUMBER.PC) localOsType.pc = true;
        if (elem.osType === OS_TYPE_ZEUS_NUMBER.IOS) localOsType.ios = true;
        if (elem.osType === OS_TYPE_ZEUS_NUMBER.ANDROID) localOsType.android = true;
      })
      setOsType(localOsType)

      const newDemographicRelations: DemographicRelation[] = [];
      // デモグラ更新
      let prefList = checkedPref
      if (resultData?.demographicRelations) {
        setAgeMin(resultData?.demographicRelations[0]?.ageMin)
        setAgeMax(resultData?.demographicRelations[0]?.ageMax)
        setGender1(resultData?.demographicRelations[0]?.genderCodeList?.split(",").includes("1"))
        setGender2(resultData?.demographicRelations[0]?.genderCodeList?.split(",").includes("2"))
        setGender3(resultData?.demographicRelations[0]?.genderCodeList?.split(",").includes("3"))
        for (let pref of resultData?.demographicRelations[0]?.prefCodeList?.split(",")) {
          prefList[parseInt(pref) - 1] = true
        }
        setCheckedPref(prefList)
        setPrefRenderId(state => state + 1)
        const newDemographicRelation: DemographicRelation = {
          ageMax: ageMax,
          ageMin: ageMin,
          prefCodeList: resultData.demographicRelations[0].prefCodeList,
          genderCodeList: resultData.demographicRelations[0].genderCodeList
        }
  
        newDemographicRelations.push(newDemographicRelation);
      }
      
      const newAdGroup: AdGroupZeus = {
        id: resultData.id ? resultData.id : 0,
        createdAt: resultData.createdAt,
        updatedAt: resultData.updatedAt,
        lastUpdateUserId: Number(resultData.lastUpdateUserId),
        adAccountId: resultData.adAccountId,
        adCampaignId: resultData.adCampaignId ? resultData.adCampaignId : 0,
        adCampaignName: resultData.adCampaignName ? resultData.adCampaignName : "",
        deliveryType: resultData.deliveryType ? resultData.deliveryType : 0,
        // menuId: resMenuId,
        name: resultData.name ? resultData.name : "",
        status: resultData.status ? resultData.status : 0,
        cpcLimit: resultData.cpcLimit ? resultData.cpcLimit : 1,
        cpcLimitOver: resultData.cpcLimitOver === false || resultData.cpcLimitOver === 'false' ? false : true,
        targetingType: resultData.targetingType ? resultData.targetingType : 0,
        customSegmentId: resultData.customSegmentId ? resultData.customSegmentId : 0,
        affinityCategoryIds: resultData.affinityCategoryIds ? resultData.affinityCategoryIds : [],
        retargetingIds: resultData.retargetingIds ? resultData.retargetingIds : [],
        osTargetings: resultData.osTargetings ? resultData.osTargetings : [],
        demographicRelations: newDemographicRelations,
        audienceRelations: resultData.audienceRelations ? resultData.audienceRelations : [],
        segmentRelations: resultData.segmentRelations ? resultData.segmentRelations : [],
        cpmLimit: resultData.cpmLimit ? resultData.cpmLimit : 1,
        billingType: resultData.billingType ? resultData.billingType : 0,
        pmpType: resultData.pmpType ? resultData.pmpType : 0,
        placementSettingId: resultData.placementSettingId ? resultData.placementSettingId : null,
      }
      setAdGroup(newAdGroup);
      setCpcLimitOver(newAdGroup.cpcLimitOver);
      console.log(newAdGroup);

      const demographicLog = formatLogFromDemographics(newAdGroup.demographicRelations);
      beforeEditRecord.current = {
        adAccountId: Number(platformAccountId),
        adCampaignId: newAdGroup.adCampaignId,
        adCampaignName: newAdGroup.adCampaignName,
        deliveryType: adGroup.deliveryType,
        name: newAdGroup.name,
        cpcLimit: resultData.cpcLimit ? resultData.cpcLimit : null,
        cpcLimitOver: newAdGroup.cpcLimitOver,
        status: newAdGroup.status,
        demographicAgeRanges: demographicLog.ageRanges,
        demographicGenders: demographicLog.genders,
        demographicAddress: demographicLog.address,
        osTypes: newAdGroup.osTargetings.map(osTargeting => {return osTargeting.osType}),
        osTypeNames: [],
        targetingType: newAdGroup.targetingType,
        customSegmentId: newAdGroup.customSegmentId,
        customSegmentName: "",
        affinityCategoryIds: newAdGroup.affinityCategoryIds,
        affinityCategoryNames: [],
        retargetingIds: newAdGroup.retargetingIds,
        retargetingNames: [],
        cpmLimit: newAdGroup.cpmLimit ?? null,
        pmpType: newAdGroup.pmpType ?? null,
        placementSettingId: newAdGroup.placementSettingId ?? null,
      }
    
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}?account_id=${platformAccountId}&campaign_id=${adGroup.adCampaignId.toString()}&group_id=${adGroupId.toString()}&sort=updated&direction=desc`
    ApolloAxios.get(url).then(response => {
      if (response.status !== 200) {
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "広告情報の取得に失敗しました",
        });
      }
      if(response.data?.length > 0) {
        setHasAd(true);
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    })
  

  }, []);


  const handleOpenConfirm = () => {
    if (!openConfirmDialog) setOpenConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    if (openConfirmDialog) setOpenConfirmDialog(false)
  }

  const handleSubmit = async (
    optionAudiences: Option[],
    optionAffinityCategories: Option[],
    optionCustomSegments: Option[],
  ) => {

    // アフィニティカテゴリバリデーション
    if (adGroup.targetingType === TARGET_TYPE.AFFINITY) {
      if (adGroup.affinityCategoryIds.length === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "アフィニティカテゴリを1つ以上選択してください。",
          }
        });
        return;
      }

      if (adGroup.affinityCategoryIds.length > AFFINITY_CATEGORY_MAX_ZEUS) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `アフィニティカテゴリは最大${AFFINITY_CATEGORY_MAX_ZEUS}個まで設定可能です。`,
          }
        });
        return;
      }
    }

    // カスタムセグメントバリデーション
    if (adGroup.targetingType === TARGET_TYPE.SEGMENT) {
      if (adGroup.customSegmentId === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "カスタムセグメントを選択してください。",
          }
        });
        return;
      }
    }

    // 配信オーディエンス設定バリデーション
    if (adGroup.targetingType === TARGET_TYPE.RETARGET) {
      if (adGroup.retargetingIds.length === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "配信オーディエンス設定を1つ以上選択してください。",
          }
        });
        return;
      }

      if (adGroup.retargetingIds.length > RETARGETING_MAX_ZEUS) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `配信オーディエンス設定は最大${RETARGETING_MAX_ZEUS}個まで設定可能です。`,
          }
        });
        return;
      }
    }

    // 年齢バリデーション
    if (ageMin && ageMax) {
      if (ageMin > ageMax) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "最小年齢が最大年齢より大きく指定されています",
          }
        });
        return;
      }
    }
    if (ageMin && !ageMax){
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "最大年齢を指定するか、最小年齢をクリアしてください",
        }
      });
      return;
    }
    if (!ageMin && ageMax){
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "最小年齢を指定するか、最大年齢をクリアしてください",
        }
      });
      return;
    }

    isExistsNotActiveAudience.current = false;
    isExistsDeletedAudience.current = false;

    optionAudiences2.current = optionAudiences
    optionAffinityCategories2.current = optionAffinityCategories
    optionCustomSegments2.current = optionCustomSegments

    if (adGroup.targetingType === TARGET_TYPE.RETARGET) {
      if (state.current.trackerId) {
        const localValAudience = await getTrackerAudience(state.current.trackerId);
        if (localValAudience.message !== "") {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: localValAudience.message
            }
          });
          return
        }
        if (localValAudience.result) {
          for (const id of adGroup.retargetingIds) {
            const val = localValAudience?.result?.find(v => v.ID === id)
            if (val?.isActive === false) {
              isExistsNotActiveAudience.current = true;
              break;
            }
          }
        }
      }

      const localValDeletedAudience = await getAccountsDeletedAudience(state.current.accountId);
      if (localValDeletedAudience.message !== "") {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: localValDeletedAudience.message
          }
        });
        return
      }
      if (localValDeletedAudience.result) {
        for (const id of adGroup.retargetingIds) {
          const val = localValDeletedAudience?.result?.find(v => v.ID === id)
          if (val) {
            isExistsDeletedAudience.current = true;
            break;
          }
        }
      }

      if (isExistsNotActiveAudience.current || isExistsDeletedAudience.current) {
        handleOpenConfirm()
        return;
      }
    }

    await handleSubmitExecute();
  }

  const handleSubmitExecute = async () => {
    let isSuccess = false;
    let beforeOsTypeNames: string[] = [];
    let afterOsTypeNames: string[] = [];
    let beforeRetargetingNames: string[] = [];
    let afterRetargetingNames: string[] = [];
    let beforeAffinityCategoryNames: string[] = [];
    let afterAffinityCategoryNames: string[] = [];
    let beforeCustomSegmentName: string = "";
    let afterCustomSegmentName: string = "";
    console.log('handleSubmit');

    // 変更前
    if (beforeEditRecord.current) {
      beforeEditRecord.current?.retargetingIds.map((id: number) => {
        const option = valueToOptionNull(id, optionAudiences2.current);
        if (valueToOptionNull(id, optionAudiences2.current)) {
          if(option) {
            beforeRetargetingNames.push(option.label);
          }
        }
      });
      beforeEditRecord.current?.affinityCategoryIds.map((id: number) => {
        const option = valueToOptionNull(id, optionAffinityCategories2.current);
        if (valueToOptionNull(id, optionAffinityCategories2.current)) {
          if(option) {
            beforeAffinityCategoryNames.push(option.label);
          }
        }
      });
      if (beforeEditRecord.current?.customSegmentId) {
        const customSegmentId: number = beforeEditRecord.current?.customSegmentId;
        const option = valueToOptionNull(customSegmentId, optionCustomSegments2.current);
        if (valueToOptionNull(customSegmentId, optionCustomSegments2.current)) {
          if(option) {
            beforeCustomSegmentName = option.label;
          }
        }
      }
      beforeEditRecord.current?.osTypes.map((osType: number) => {
        const option = valueToOptionNull(osType, options_ostype_zeus_number);
        if(option) {
          beforeOsTypeNames.push(option.label)
        }
      })
      beforeEditRecord.current = {
        ...beforeEditRecord.current,
        cpcLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP || isCpcLimitDisabled ? null : beforeEditRecord.current?.cpcLimit,
        cpmLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? null : beforeEditRecord.current?.cpmLimit,
        osTypeNames: beforeOsTypeNames,
        customSegmentName: beforeCustomSegmentName,
        affinityCategoryNames: beforeAffinityCategoryNames,
        retargetingNames: beforeRetargetingNames,
      };
    }

    // 変更後
    const apiBody: AdGroupUpdate = {
      name: adGroup.name,
      cpcLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP || isCpcLimitDisabled ? null : Number(adGroup.cpcLimit),
      cpcLimitOver: cpcLimitOver,
      status: adGroup.status,
      targetingType: adGroup.targetingType,
      customSegmentId: adGroup.targetingType === TARGET_TYPE.SEGMENT ? adGroup.customSegmentId : null,
      affinityCategoryIds: adGroup.targetingType === TARGET_TYPE.AFFINITY ? adGroup.affinityCategoryIds : null,
      retargetingIds: adGroup.targetingType === TARGET_TYPE.RETARGET ? adGroup.retargetingIds : null,
      demographicRelations: [],
      audienceRelations: [],
      segmentRelations: [],
      cpmLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? null : Number(adGroup.cpmLimit),
      placementSettingId: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? null : adGroup.placementSettingId,
    }

    if (adGroup.targetingType === TARGET_TYPE.AFFINITY) {
      const affinityCategoryIds: number[] = [];
      adGroup.affinityCategoryIds?.map((id: number) => {
        affinityCategoryIds.push(id);
        const option = valueToOptionNull(id, optionAffinityCategories2.current);
        if(option) {
          afterAffinityCategoryNames.push(option.label);
        }
      })
    }

    if (adGroup.targetingType === TARGET_TYPE.SEGMENT) {
      const option = valueToOptionNull(adGroup.customSegmentId, optionCustomSegments2.current);
      if(option) {
        afterCustomSegmentName = option.label;
      }
    }

    if (adGroup.targetingType === TARGET_TYPE.RETARGET) {
      const retargetingIds: number[] = [];
      adGroup.retargetingIds?.map((id: number) => {
        retargetingIds.push(id);
        const option = valueToOptionNull(id, optionAudiences2.current);
        if(option) {
          afterRetargetingNames.push(option.label);
        }
      });
    }

    // 配信OS
    if (osType.pc) {
      const option = valueToOptionNull(OS_TYPE_ZEUS_NUMBER.PC, options_ostype_zeus_number);
      if(option) {
        afterOsTypeNames.push(option.label)
      }
    }
    if (osType.ios) {
      const option = valueToOptionNull(OS_TYPE_ZEUS_NUMBER.IOS, options_ostype_zeus_number);
      if(option) {
        afterOsTypeNames.push(option.label)
      }
    }
    if (osType.android) {
      const option = valueToOptionNull(OS_TYPE_ZEUS_NUMBER.ANDROID, options_ostype_zeus_number);
      if(option) {
        afterOsTypeNames.push(option.label)
      }
    }

    //デモグラ更新
    // 性別
    const genderList: number[] = [];
    if (gender1) {genderList.push(1)};
    if (gender2) {genderList.push(2)};
    if (gender3) {genderList.push(3)};
    let genderString: string | null = ""
    if (genderList.length > 0) {
      genderString = genderList.join(",")
    } else {
      genderString = null
    }

    // 居住地
    const prefList: number[] = [];
    for (let i = 0; i < checkedPref.length; i++ ) {
      if (checkedPref[i]) {
        prefList.push(i + 1)
      }
    }
    let prefString: string | null = ""
    if (prefList.length > 0) {
      prefString = prefList.join(",")
    } else {
      prefString = null
    }

    const demographicRelation: DemographicRelation = {
      ageMin: ageMin?? null,
      ageMax: ageMax?? null,
      genderCodeList: genderString,
      prefCodeList: prefString,
    }
    apiBody.demographicRelations = ([demographicRelation])

    // const ageRange : DemographicAgeRange = {ageMin:ageMin, ageMax:ageMax}
    // demographicAgeRanges.push(ageRange);
    // const body = {
    //   name: adGroup.name,
    //   segmentAffinityIds: segmentAffinityIds,
    //   segmentCustomIds: segmentCustomIds,
    //   status: adGroup.status,
    //   demographicAgeRanges: demographicAgeRanges,
    //   demographicIds: demographicIds,
    //   osTargeting: osTargeting,
    // }

    const demographicLog = formatLogFromDemographics(adGroup.demographicRelations);
    const executeLog = createUserLog(
      state,
      "パフォーマンス広告",
      "広告グループ",
      "更新",
      "広告グループ（パフォーマンス広告）編集",
      beforeEditRecord.current,
      {
        adAccountId: Number(platformAccountId),
        adCampaignId: adGroup.adCampaignId,
        adCampaignName: adGroup.adCampaignName,
        deliveryType: adGroup.deliveryType,
        name: adGroup.name,
        cpcLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.DSP || isCpcLimitDisabled ? null : adGroup.cpcLimit,
        cpcLimitOver: cpcLimitOver,
        status: adGroup.status,
        demographicAgeRanges: demographicLog.ageRanges,
        demographicGenders: demographicLog.genders,
        demographicAddress: demographicLog.address,
        osTypes: adGroup.osTargetings.map(osTargeting => {return osTargeting.osType}),
        osTypeNames: afterOsTypeNames,
        targetingType: adGroup.targetingType,
        customSegmentId: adGroup.targetingType === TARGET_TYPE.SEGMENT ? adGroup.customSegmentId : 0,
        customSegmentName: adGroup.targetingType === TARGET_TYPE.SEGMENT ? afterCustomSegmentName : "",
        affinityCategoryIds: adGroup.targetingType === TARGET_TYPE.AFFINITY ? adGroup.affinityCategoryIds : [],
        affinityCategoryNames: adGroup.targetingType === TARGET_TYPE.AFFINITY ? afterAffinityCategoryNames : [],
        retargetingIds: adGroup.targetingType === TARGET_TYPE.RETARGET ? adGroup.retargetingIds : [],
        retargetingNames: adGroup.targetingType === TARGET_TYPE.RETARGET ? afterRetargetingNames : [],
        cpmLimit: adGroup.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE ? null : adGroup.cpmLimit,
        pmpType: adGroup.pmpType,
        placementSettingId: adGroup.placementSettingId,
      },
      adGroup.adCampaignId.toString(), // キャンペーンID
      adGroup.adCampaignName, // キャンペーン名
      String(adGroupId), // 広告グループID
      beforeEditRecord.current?.name ? beforeEditRecord.current.name : "", // 広告グループ名
    );
    executeLog.targetID = String(adGroupId);
    executeLog.targetName = beforeEditRecord.current?.name ? beforeEditRecord.current.name : "";
    ApolloEventRecord({...executeLog, logType: "execute"});
    console.log('executeLog');
    console.log(executeLog);
    console.log('apiBody');
    console.log(apiBody);
    
    const url = process.env.REACT_APP_API_ENDPOINT + get_zeus_ad_group_path + "/" + adGroupId;
    ApolloAxios.patch(url, apiBody).then(response => {
      const res: ApiResponse = response.data;
      if (response.status !== 200) {
        return Promise.reject({
          open: true,
          type: getResultType(response.status === 400 ? -1 : -9),
          errmsg: "広告グループの更新に失敗しました",
        });
      } else if (response.data != null && response.data.resultCode != 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
          }
        });
      } else {
        isSuccess = true;
        adGroupData.current = adGroup;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: "広告グループを更新しました"
          }
        });
      }

    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executeLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        targetName: adGroupData.current ? adGroupData.current?.name : "",
        result: isSuccess ? "成功" : "失敗",
        adGroupName: adGroupData.current ? adGroupData.current?.name : executeLog.adGroupName,
      };
      ApolloEventRecord({...resultLog, logType: "result"});
      if (isSuccess) listReloadFunc && listReloadFunc();
    });
  };

  const handleGoBack = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  }

  return (
    <React.Fragment>
      <AdGroupFormZeus
        platformAccountId={Number(platformAccountId)}
        adGroupId={Number(adGroupId)}
        adGroupState={{
          adGroup: adGroup,
          setAdGroup: setAdGroup,
          osType: osType,
          setOsType:setOsType,
          cpcLimitOver: cpcLimitOver,
          setCpcLimitOver:setCpcLimitOver,
          isCpcLimitDisabled: isCpcLimitDisabled,
          setIsCpcLimitDisabled: setIsCpcLimitDisabled,
          errors: errors,
          setError: setError
        }}
        demograStatus={{
          ageMin: ageMin,
          setAgeMin: setAgeMin,
          ageMax: ageMax,
          setAgeMax: setAgeMax,
          gender1: gender1,
          setGender1: setGender1,
          gender2: gender2,
          setGender2: setGender2,
          gender3: gender3,
          setGender3: setGender3,
          checkedPref: checkedPref,
          setCheckedPref: setCheckedPref,
          prefRenderId: prefRenderId,
          setPrefRenderId: setPrefRenderId
        }}
        hasAd={hasAd}
        submitAction={handleSubmit}
        goBackAction={handleGoBack}
      />
      <ApolloDialog open={openConfirmDialog} setOpen={setOpenConfirmDialog}>
        <ApolloConfirmNotActiveDialog
          isExistsNotActiveAudience={isExistsNotActiveAudience.current}
          isExistsDeletedAudience={isExistsDeletedAudience.current}
          handleSave={handleSubmitExecute}
          handleClose={handleCloseConfirm}
        />
      </ApolloDialog>
    </React.Fragment>
  )
};

const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
  campaignId?: string,
  campaignName?: string,
  adGroupId?: string,
  adGroupName?: string,
) => {
  const items: ItemList[] = [
    createUserLogItemListFromNumber("プラットフォームアカウントID", "adAccountId", beforeInfo, afterInfo),
    createUserLogItemListFromString("広告グループ名", "name", beforeInfo, afterInfo),
    createUserLogItemListByOption("ステータス", "status", beforeInfo, afterInfo, options_state_edit),
    createUserLogItemListFromNumber("目標CPC", "cpcLimit", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("上限CPM", "cpmLimit", beforeInfo, afterInfo),
    createUserLogItemListFromNumber("入札制御", "cpcLimitOver", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("デモグラ情報_性別", "demographicGenders", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("デモグラ情報_年齢", "demographicAgeRanges", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("デモグラ情報_居住地", "demographicAddress", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("配信OS", "osTypeNames", beforeInfo, afterInfo),
    createUserLogItemListByOption("ターゲティング情報", "targetingType", beforeInfo, afterInfo, options_zeus_ad_target),
    createUserLogItemListFromArrayAddSB("アフィニティカテゴリ", "affinityCategoryNames", beforeInfo, afterInfo),
    createUserLogItemListFromString("カスタムセグメント", "customSegmentName", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("配信オーディエンス設定", "retargetingNames", beforeInfo, afterInfo),
  ];

  const retObj = createLogDate(
    apolloContex,
    menu,
    category,
    actionType,
    displayName,
    items,
    campaignId,
    campaignName,
    adGroupId,
    adGroupName,
  );

  return retObj
}

export default AdGroupEditZeus;
